import(/* webpackMode: "eager", webpackExports: ["NotFound"] */ "/builds/PortailVente/mCommerce-SSR/b-you/src/components/not-found.tsx");
